function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  .top-div {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    .title {\n      width: auto;\n      line-height: 1.6rem;\n    }\n    .card-status {\n      height: max-content;\n      display: flex;\n      justify-content: flex-end;\n      padding-top: 3px;\n      width: 7rem;\n      .label {\n        height: 1.125rem;\n        padding: 2px 6px;\n        color: ", ";\n        font-weight: ", ";\n        font-size: ", ";\n        border-radius: 25px;\n        line-height: 16px;\n      }\n      img {\n        padding-left: 0.75rem;\n        margin-top: 0.25rem;\n        height: 0.6875rem;\n        cursor: pointer;\n      }\n    }\n  }\n  .subtitle {\n    margin-top: -5px;\n    margin-bottom: 1.1rem;\n    line-height: 1.2rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: 4px;\n  padding: 16px;\n  box-shadow: 0px 1px 4px rgba(217, 217, 217, 0.21);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import Text from '../../atoms/Text';
import Label from '../../atoms/Label';
import arrowIcon from '../../../assets/icons/arrowIcon.svg';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import CustomButton from '../../atoms/CustomButton';
import Divider from '@material-ui/core/Divider';
var CardContainer = styled.div(_templateObject(), function (props) {
  return props.theme.background;
});
var CardHeader = styled.div(_templateObject2(), function (props) {
  return props.theme.status[props.labelTextColor];
}, function (props) {
  return props.theme.fontWeight.primary;
}, function (props) {
  return props.theme.typeScale.copyrightText;
});
var FooterContainer = styled.div(_templateObject3());
var BodyContainer = styled.div(_templateObject4());

var Card = function Card(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      status = _ref.status,
      arrow = _ref.arrow,
      children = _ref.children,
      handleArrow = _ref.handleArrow,
      labelColor = _ref.labelColor,
      labelTextColor = _ref.labelTextColor,
      defaultButtonText = _ref.defaultButtonText,
      handleDefaultButton = _ref.handleDefaultButton,
      buttonIcon = _ref.buttonIcon,
      handleIconButton = _ref.handleIconButton,
      footer = _ref.footer,
      body = _ref.body,
      bodyClass = _ref.bodyClass,
      footerClass = _ref.footerClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle", "status", "arrow", "children", "handleArrow", "labelColor", "labelTextColor", "defaultButtonText", "handleDefaultButton", "buttonIcon", "handleIconButton", "footer", "body", "bodyClass", "footerClass"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardContainer, rest, /*#__PURE__*/React.createElement(CardHeader, _extends({
    labelTextColor: labelTextColor
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "top-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(Text, {
    text: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-status"
  }, status ? /*#__PURE__*/React.createElement(Label, {
    label: status,
    color: labelColor ? labelColor : 'orange',
    size: "copyrightText",
    className: "label"
  }) : '', arrow ? /*#__PURE__*/React.createElement("img", {
    src: arrowIcon
  }) : '')), subtitle ? /*#__PURE__*/React.createElement(Text, {
    text: subtitle,
    color: "bodyTextLight",
    size: "copyrightText",
    className: "subtitle"
  }) : ''), body && /*#__PURE__*/React.createElement(BodyContainer, {
    className: bodyClass
  }, body), footer && /*#__PURE__*/React.createElement(Divider, null), footer && /*#__PURE__*/React.createElement(FooterContainer, {
    className: footerClass
  }, footer)));
};

Card.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  handleArrow: PropTypes.func,
  status: PropTypes.string,
  labelColor: PropTypes.string,
  labelTextColor: PropTypes.string,
  bodyClass: PropTypes.string,
  footerClass: PropTypes.string
} : {};
Card.defaultProps = {
  theme: defaultTheme,
  subtitle: '',
  status: '',
  handleArrow: function handleArrow() {},
  labelColor: 'yellow',
  labelTextColor: 'yellow',
  bodyClass: '',
  footerClass: ''
};
export default Card;